<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
  width:100%;
  height:100%;
  margin:0;
  padding:0;
}
body{
  overflow: hidden;
}
div,span,a,li,button,select{
  font-family: MicroSoft YaHei;
}
ul{
  padding:0;
  margin:0;
  list-style: none;
}
#app{
  width:100%;
  height:100%;
  overflow:auto;
}
.fl{
  float:left;
}
.fr{
  float:right;
}
.cle::after{
  content:'';
  height: 0;
  display: block;
  visibility: visible;
  clear: both;
}
.cle{
  zoom:1;
}
.hide{
  display:none;
}
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue